import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as React from "react";

import { BodyText } from "styles";

import {
  BoardPersonDetails,
  BoardPersonWrapper,
  PersonImage,
  PersonTitle,
} from "./Person.styles";

type Props = {
  details: Queries.SanityBoard;
};

export const BoardPerson: React.FC<Props> = ({ details }: Props) => {
  const { name, prevCompanyImage, profileImage, summary } = details;

  const profileImageSrc =
    profileImage?.asset?.gatsbyImageData.images.fallback?.src;
  const prevCompanyImageSrc = prevCompanyImage?.asset;

  return (
    <BoardPersonWrapper>
      {profileImageSrc && (
        <PersonImage
          className="rounded-lg"
          $isRelative
          $image={profileImageSrc}
        />
      )}
      <BoardPersonDetails className="py-4">
        <div>
          <PersonTitle>
            <BodyText $variant="b5bold" $hasPadding={false}>
              {name}
            </BodyText>
          </PersonTitle>
          <BodyText $variant="b5reg" $hasPadding={false}>
            {summary}
          </BodyText>
          {prevCompanyImageSrc && (
            <GatsbyImage
              className="mt-4 max-w-[120px]"
              image={getImage(prevCompanyImageSrc)}
              alt={name || "image"}
            />
          )}
        </div>
      </BoardPersonDetails>
    </BoardPersonWrapper>
  );
};
